import X from './meet_x.js' 

export default (id, videoSession) => {
  return X.attachVideo(id, videoSession)
}

